import { reactive, toRaw } from 'vue'

export const BookingStore = reactive({
    current_step: 1,
    configs: null,

    selected_prestations: [],
    selected_category: null,
    selected_location: null,
    selected_agenda: null,

    rdvToModify: null,

    user_infos: null,
    clients: [],

  get_configs(){
    return this.configs;
  },

  set_configs(configs){
    this.configs = configs;
  },

  select_prestations(selected_prestations, selected_location, selected_agenda){
    this.selected_prestations = selected_prestations;
    this.selected_agenda = selected_agenda;
    this.selected_location = selected_location;
  },

  set_user_infos(user_infos){
    this.user_infos = user_infos;
  },

  get_user_infos(){
    return this.user_infos;
  },

  set_clients(clients){
    this.clients = clients;
  },
  
  get_clients(){
    return this.clients;
  },

  set_step(value){
    this.current_step = value;
  },

  get_groupe_size(){
    let size = 0;
    for (const presta of toRaw(this.selected_prestations)) {
      if (presta.is_group && presta.allow_subgroup) size += presta.group_size;
    }
    if(size < 1) size = 1;
    console.log('Booking store get group_size', size, toRaw(this.selected_prestations));
    
    return parseInt(size, 10);
  },

  getSelectedPrestationsIdsAsString() {
    // on utilise toRaw pour éviter les proxies Vue
    const prestations = toRaw(this.selected_prestations);
  
    // on filtre les objets valides et on mappe vers leur prestation_id
    const ids = prestations
      .filter(presta => presta && presta.prestation_id !== undefined)
      .map(presta => presta.prestation_id);
  
    // on retourne une chaîne séparée par des virgules
    return ids.join(',');
  },

  getFirstSelectedPrestation(){
    if(this.selected_prestations.length == 0) return null;
    return this.selected_prestations[0];
  },

  select_location(location) {
      this.selected_location = location;
  },

  setAgenda(agenda){
    this.selected_agenda = agenda;
  }
})